import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createIntl, createIntlCache, IntlProvider } from 'react-intl';
import { Provider, updateIntl } from 'react-intl-redux';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { CssBaseline, Fab, Drawer, Badge } from '@material-ui/core';
import { ApolloProvider } from 'react-apollo';
import getMessages from '../lib/i18n/getMessages';
import { CurrencyProvider } from '../hooks/useCurrency';
import themes from '../lib/themes';
import configureStore from '../store/findBobPublicStore';
import ChatIcon from '@material-ui/icons/Chat';
import { Close } from '@material-ui/icons';
import client from '../lib/apolloClient';
import { withStyles } from '@material-ui/core/styles';
import LeadDrawer from '../components/LeadDrawer/LeadDrawer';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { get } from 'lodash';

const cache = createIntlCache();

class LeadDrawerContainer extends Component {
  constructor(props) {
    super(props);

    let store = {};
    if (document.store) {
      store = document.store;
    } else {
      store = configureStore(props);
    }
    this.store = store;
    updateIntl({
      locale: window.locale || 'en',
      messages: getMessages(window.locale || 'en'),
    }, cache);
    this.state = {
      openDrawer: false,
      store: store,
    };
  }

  setOpenDrawer = (open) => {
    this.setState({ openDrawer: open });
  };

  render() {
    const theme = this.props.theme;
    const { classes } = this.props;
    const { openDrawer } = this.state;

    return (
      <MuiThemeProvider theme={createTheme(theme)}>
        <CssBaseline />
        <Provider store={this.state.store} props>
          <ApolloProvider client={client}>
            <IntlProvider messages={getMessages(window.locale || 'en')} locale={window.locale}>
              <Fab variant='circular' className={classes.fab} onClick={() => this.setOpenDrawer(!openDrawer)}>
                  { openDrawer ? <Close /> : <ChatIcon /> }
              </Fab>
              { openDrawer ? <LeadDrawer {...this.props} client={client} /> : <span/>}

            </IntlProvider>
          </ApolloProvider>
        </Provider>
      </MuiThemeProvider>
    );
  }
}

const styles = theme => ({
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(6),
  },
});

const LeadDrawerWithQuery = (props) => {
  return (
    <LeadDrawerContainer {...props} />
  );
}


const LeadDrawerContainerWithStyles = withStyles(styles)(LeadDrawerWithQuery);

const LeadDrawerContainerWithContext = (props, railsContext) => {
  let theme = themes[railsContext.theme_name];
  window.locale = railsContext.i18nLocale || 'en';
  window.currency = (railsContext && railsContext.currency) || window.currency || 'USD';
  const { company } = railsContext;
  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || window.currency || 'USD'}>
      <LeadDrawerContainerWithStyles {...props} company={company} theme={theme} />
    </CurrencyProvider>
  );
}

export default LeadDrawerContainerWithContext;